import {MeterSensorModel} from "../meter-sensor-model";

export class SensorsCounterModel {
  counterSensors: MeterSensorModel[];

  constructor() {
    this.counterSensors = [];
  }

  public static initialize(model: SensorsCounterModel): void {
    if (!model.counterSensors) {
      model.counterSensors = [];
    }
  }
}
